import React, { useEffect, useRef } from "react";
import { DataSet } from "vis-data/peer";
import { Network } from "vis-network/peer";
import "vis-network/styles/vis-network.css";
import type {FlattenedItem, SensorContext, TreeItems} from '../../Tree/types';
// import { tagFromSlug, useKnowledgeNetworkQuery } from "../tags";

type RelatedNetworkProps = {
	data: FlattenedItem[];
};

const RelatedNetwork: React.FC<RelatedNetworkProps> = ({ data
}) => {
	const widthConstraint = {
		maximum: 150
	};
	const color = {
		border: "#000000ff",
		background: "#7CCB7D",
		highlight: { border: "#314A5E", background: "#e6b26eff" },
		hover: { border: "#314A5E", background: "#FFFFFF" }
	};
	const font = {
		color: "#411811"
	};
	
    const max = data.reduce(function(prev, current) {
      return (prev && prev.depth > current.depth) ? prev : current
    })
    // create an array with nodes
    const nodes = data.map((i)=> {

      // TODO: Track the highest depth value and assign this value to the level property of any node created by


      const depth = i.children.length > 0 ? i.depth : max.depth;

      return {
        id: i.id,
				label: i.title,
				title: i.title + " -Level:" + depth,
        level: depth,
        shape: "box",
        color: {
					...color,
					background: "#e6e7e7ff"
				},
				font: {
					color: "#1b1b1dee",
          			size: 24
				},
        widthConstraint: {
          maximum: 325
        }
      };
    });

    // create an array with edges
    const edges = data.map((i)=> {
      return {
        from: i.parentId,
				to: i.id
      };
    });

	// const nodes = (
	// 	related.articles?.map((a) => {
	// 		return {
	// 			id: a.fields.slug,
	// 			label: a.frontmatter.title,
	// 			title: a.frontmatter.description,
	// 			slug: a.fields.slug,
	// 			tag: tagFromSlug(a.fields.slug),
	// 			tags: a.frontmatter.tags,
	// 			shape: "box",
	// 			widthConstraint,
	// 			color,
	// 			font
	// 		};
	// 	}) || []
	// )
	// 	.concat(
	// 		related.tags?.map((t) => {
	// 			return {
	// 				id: t.fields.slug,
	// 				label: t.frontmatter.title,
	// 				title: t.frontmatter.description,
	// 				slug: t.fields.slug,
	// 				tag: tagFromSlug(t.fields.slug),
	// 				tags: t.frontmatter.tags,
	// 				shape: "ellipse",
	// 				widthConstraint,
	// 				color,
	// 				font
	// 			};
	// 		}) || []
	// 	)
	// 	.concat([
	// 		{
	// 			id: locationPathname,
	// 			label: title,
	// 			title: "This article",
	// 			slug: locationPathname,
	// 			tag: tagFromSlug(locationPathname),
	// 			tags,
	// 			shape: "circle",
	// 			widthConstraint,
	// 			color: {
	// 				...color,
	// 				background: "#411811"
	// 			},
	// 			font: {
	// 				color: "#7CCB7D"
	// 			}
	// 		}
	// 	])
	// 	.filter(
	// 		(node, index, self) =>
	// 			index === self.findIndex((candidateNode) => candidateNode.id === node.id)
	// 	);

	const approxLinesOfText = Math.ceil(
		nodes.reduce((prev, curr) => prev + (curr.label?.length || 0), 0) / 14
	);

	// const edges = nodes.reduce<{ to: string; from: string }[]>((prev, current) => {
	// 	return prev.concat(
	// 		nodes
	// 			.filter((n) => current.tags?.includes(n.tag))
	// 			.map((n) => {
	// 				return { from: n.id, to: current.id, length: 175, arrows: { to: true } };
	// 			}) || []
	// 	);
	// }, []);



	const visJsRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const network =
			visJsRef.current &&
			new Network(
				visJsRef.current,
				{ nodes, edges },
				{
					autoResize: false,
          			layout: {
						randomSeed: 1,
          				improvedLayout: false,
            			hierarchical: {
							enabled:true,
							levelSeparation: 125,
							nodeSpacing: 550,
							treeSpacing: 325,
							blockShifting: false,
							edgeMinimization: false,
							parentCentralization: true,
							direction: 'DU',        // UD, DU, LR, RL
							sortMethod: 'directed',  // hubsize, directed
							shakeTowards: 'leaves'  // roots, leaves
						}
          			},
					physics:{
						enabled: true,
						// barnesHut: {
						//   theta: 0.5,
						//   gravitationalConstant: -2000,
						//   centralGravity: 0.3,
						//   springLength: 95,
						//   springConstant: 0.04,
						//   damping: 0.09,
						//   avoidOverlap: 1
						// },
						// forceAtlas2Based: {
						//   theta: 0.5,
						//   gravitationalConstant: -50,
						//   centralGravity: 0.01,
						//   springConstant: 0.08,
						//   springLength: 100,
						//   damping: 0.4,
						//   avoidOverlap: 0
						// },
						repulsion: {
						centralGravity: 0.2,
						springLength: 200,
						springConstant: 0.05,
						nodeDistance: 100,
						damping: 0.09
						},
						hierarchicalRepulsion: {
						centralGravity: 0.0,
						springLength: 100,
						springConstant: 0.01,
						nodeDistance: 120,
						damping: 0.09,
						avoidOverlap: 1
						},
						// maxVelocity: 50,
						// minVelocity: 0.1,
						// solver: 'barnesHut',
						// stabilization: {
						//   enabled: true,
						//   iterations: 1000,
						//   updateInterval: 100,
						//   onlyDynamicEdges: false,
						//   fit: true
						// },
						// timestep: 0.5,
						// adaptiveTimestep: true,
						// wind: { x: 0, y: 0 }
					},
					edges: {
						color: "#000000ff",
						smooth: {
							enabled: true,
							type: 'cubicBezier',
							forceDirection: 'vertical',
							roundness: 1
						}
					}
				}
			);
		network?.on("selectNode", (event: { nodes: string[] }) => {
			if (event.nodes?.length === 1) {
				// window.location.href = event.nodes[0];
			}
		});
		network?.on("stabilized", function () {
			network?.fit(
				{
					//FIXME: Buggy AF...
					nodes: [nodes[0].id, nodes[5].id,  nodes[9].id ],
					// nodes: Array.from(Array(10).keys())
					// minZoomLevel: 1.5,
					// maxZoomLevel: 2
					// animation?: boolean | {
					// 	duration?: number
					// 	easingFunction?: string
					// }
				}
			);
		});
	}, [visJsRef, nodes, edges]);

	const height = 2 * (approxLinesOfText + edges.length);

	return (
		<div
			ref={visJsRef}
			style={{
				height: "100vh",
				// height: `${height < 150 ? 150 : height}vh`,
				// width: `${8 * nodes.length + 8}em`,
				width: "100%",
				// flex-basis: "100%",
				maxWidth: "100%",
				minWidth: "10%",
				minHeight: "10%",
				maxHeight: "100%",
        		background: "#050d1a59"
			}}
		/>
	);
};

export default RelatedNetwork;